import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TChangeHistoryStore } from './types';

const getChangeHistoryState = (state: TStoreState): TChangeHistoryStore => state.changeHistory;

export const getChangeHistory = createSelector(
	[getChangeHistoryState],
	(state: TChangeHistoryStore) => state.changeHistory,
);

export const getChangeHistoryLoading = createSelector(
	[getChangeHistoryState],
	(state: TChangeHistoryStore) => state.changeHistoryLoading,
);

export const getChangeHistoryByEm = createSelector(
	[getChangeHistoryState],
	(state: TChangeHistoryStore) => state.changeHistoryByEm,
);

export const getChangeHistoryByEmLoading = createSelector(
	[getChangeHistoryState],
	(state: TChangeHistoryStore) => state.changeHistoryByEmLoading,
);

export const getChangeHistoryByUser = createSelector(
	[getChangeHistoryState],
	(state: TChangeHistoryStore) => state.changeHistoryByUser,
);

export const getChangeHistoryByUserLoading = createSelector(
	[getChangeHistoryState],
	(state: TChangeHistoryStore) => state.changeHistoryByUserLoading,
);
